import { ImageAnnotationRecord } from "models/view-models/block-configurations/image-annotation-record";
import ServiceHookFactory from "../service-hook-factory";
interface ImageAnnotationPathParams {}

interface ImageAnnotationResourcePathParams extends ImageAnnotationPathParams {
    id: number;
}
export interface ImageAnnotationCreateParams {
    imageBlockId: number;
    coordinateX: number;
    coordinateY: number;
    note: string;
    precedingAnnotationId?: number;
}

const resourceType = ImageAnnotationRecord;
const baseEndpoint = "image-annotations";
const resourceEndpoint = `${baseEndpoint}/:id`;

const ImageAnnotationService = {
    useCreate: ServiceHookFactory.useCreateFromPostParams<
        ImageAnnotationRecord,
        ImageAnnotationCreateParams
    >(resourceType, baseEndpoint),
    useUpdate: ServiceHookFactory.useUpdate<
        ImageAnnotationRecord,
        ImageAnnotationResourcePathParams
    >(resourceType, resourceEndpoint),
    useDelete: ServiceHookFactory.useDelete(resourceEndpoint),
};

export default ImageAnnotationService;
